module.exports = __webpack_public_path__ + "static/media/carfixio-5.f11522fa.jpg";